var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "container" },
    [
      _c(
        "div",
        { staticClass: "title" },
        [
          _c(
            "el-breadcrumb",
            { attrs: { separator: "/" } },
            [
              _c("el-breadcrumb-item", [_vm._v("平台建设")]),
              _c("el-breadcrumb-item", [_vm._v("基础信息")]),
              _c("el-breadcrumb-item", [_vm._v("资源信息")])
            ],
            1
          )
        ],
        1
      ),
      _c("div", { staticClass: "title-en" }, [_vm._v("1.园区及机房(在维)")]),
      _c(
        "el-card",
        { staticClass: "box-card" },
        [
          _c(
            "el-table",
            {
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.datacenterData,
                "header-cell-style": _vm.headerStyle,
                "row-class-name": _vm.tableRowClassName
              }
            },
            [
              _c("el-table-column", {
                attrs: {
                  prop: "region",
                  label: "地区",
                  align: "center",
                  width: "100"
                }
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "province",
                  label: "省/直辖市",
                  align: "center",
                  width: "120"
                }
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "area",
                  label: "区域/园区",
                  align: "center",
                  width: "120"
                }
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "type",
                  label: "机房类型",
                  align: "center",
                  width: "100"
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c("span", { staticStyle: { color: "#219aff" } }, [
                          _vm._v(_vm._s(scope.row.type))
                        ])
                      ]
                    }
                  }
                ])
              }),
              _c("el-table-column", {
                attrs: { prop: "name", label: "一级机房名称", align: "center" }
              }),
              _c("el-table-column", {
                attrs: { prop: "startDate", label: "起始日期", align: "center" }
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "status",
                  label: "状态",
                  align: "center",
                  width: "80"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c("div", { staticClass: "title-en" }, [_vm._v("2.值班账号")]),
      _c(
        "el-card",
        { staticClass: "box-card" },
        [
          _c(
            "el-table",
            {
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.dutyAccountData,
                "header-cell-style": _vm.headerStyle,
                "row-class-name": _vm.tableRowClassName
              }
            },
            [
              _c("el-table-column", {
                attrs: {
                  prop: "region",
                  label: "地区",
                  align: "center",
                  width: "100"
                }
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "province",
                  label: "省/直辖市",
                  align: "center",
                  width: "120"
                }
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "area",
                  label: "区域/园区",
                  align: "center",
                  width: "120"
                }
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "accountName",
                  label: "值班账号名称",
                  align: "center"
                }
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "phone",
                  label: "值班账号联系电话",
                  align: "center"
                }
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "owner",
                  label: "电话所属人员姓名",
                  align: "center"
                }
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "status",
                  label: "状态",
                  align: "center",
                  width: "80"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c("div", { staticClass: "title-en" }, [_vm._v("3.岗位与标签")]),
      _c(
        "el-card",
        { staticClass: "box-card" },
        [
          _c(
            "el-table",
            {
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.positionTagData,
                "header-cell-style": _vm.headerStyle,
                "row-class-name": _vm.tableRowClassName
              }
            },
            [
              _c("el-table-column", {
                attrs: {
                  prop: "project",
                  label: "项目",
                  align: "center",
                  width: "100"
                }
              }),
              _c("el-table-column", {
                attrs: { prop: "type1", label: "类型1", align: "center" }
              }),
              _c("el-table-column", {
                attrs: { prop: "type2", label: "类型2", align: "center" }
              }),
              _c("el-table-column", {
                attrs: { prop: "type3", label: "类型3", align: "center" }
              }),
              _c("el-table-column", {
                attrs: { prop: "type4", label: "类型4", align: "center" }
              }),
              _c("el-table-column", {
                attrs: { prop: "type5", label: "类型5", align: "center" }
              }),
              _c("el-table-column", {
                attrs: { prop: "type6", label: "类型6", align: "center" }
              }),
              _c("el-table-column", {
                attrs: { prop: "type7", label: "类型7", align: "center" }
              }),
              _c("el-table-column", {
                attrs: { prop: "type8", label: "类型8", align: "center" }
              }),
              _c("el-table-column", {
                attrs: { prop: "type9", label: "类型9", align: "center" }
              }),
              _c("el-table-column", {
                attrs: { prop: "type10", label: "类型10", align: "center" }
              })
            ],
            1
          )
        ],
        1
      ),
      _c("div", { staticClass: "title-en" }, [_vm._v("4.合作单位(外部)")]),
      _c(
        "el-card",
        { staticClass: "box-card" },
        [
          _c("resource-table", {
            attrs: { "header-style": _vm.headerStyle },
            on: {
              edit: _vm.handleEdit,
              delete: _vm.handleDelete,
              history: _vm.handleHistory
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }